import React from 'react';
import { getThemeComponent } from '@/utils/themeImports';
import { specificThemeRender } from '@/utils/specificThemeRender';
import { useSSRSelector } from 'src/redux';
import ErrorMsg from './ErrorMsg';

const Error404 = () => {
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);
  return (
    <div className="ErrorPage_wrapper">
      {specificThemeRender(storeInfo)?.components?.Header?.map((layout) => {
        return getThemeComponent(layout.sub_type, layout.name, layout);
      })}
      <ErrorMsg />
      <section className="EroorPage_body_wrapper">
        {specificThemeRender(storeInfo)?.components?.Footer?.map((layout) => {
          return getThemeComponent(layout.sub_type, layout.name, layout);
        })}
      </section>
    </div>
  );
};

export default Error404;
